module.exports = __webpack_public_path__ + "img/hoplucpostlogowhite.b4ae997f.png";